<template>

  <div class="section section-white">
    <el-card>
      <el-alert
              title="优惠券创建说明"
              type="info"
              description="展示方式分两种 1：组合（只需要上传一个优惠券图【组合】图片，每个优惠券不用上传图片）2：单个优惠券展示（不用上传优惠券组【合图】图片，在每个优惠券上单独上传图片）。建议展示方式选择 【组合图片展示】
              活动关键字说明：填写后会根据关键字跳转到搜索商品列表中"
              show-icon>
      </el-alert>
    </el-card>
    <el-form v-model="form" label-width="160px">

      <el-form-item label="活动banner" hide-requied-aterisk="true">

        <div @click="handleImgPicker('a',0)" class="upload-box">
          <img v-if="form.banner" :src="form.banner" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
      </el-form-item>

      <el-form-item label="活动名称">
        <el-input v-model="form.name"  placeholder="请输入活动名称"></el-input>
      </el-form-item>

      <el-form-item label="活动时间">
        <el-input v-model="form.activity_time"  placeholder="活动时间"></el-input>
      </el-form-item>
      <el-form-item label="展示方式">
        <el-radio-group v-model="form.show_type">
          <el-radio :label="1">组合图片展示 </el-radio>
          <el-radio :label="0">单个优惠券展示</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="优惠券图【组合】">
        <div @click="handleImgPicker('b',0)" class="upload-box">
          <img v-if="form.cards_img" :src="form.cards_img" class="avatar"/>
          <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
        </div>
      </el-form-item>
      <el-form-item label="活动关键字">
        <el-input v-model="form.key_words"  placeholder="活动关键字"></el-input>
      </el-form-item>
      <el-form-item label="活动说明">
        <el-input type="textarea" v-model="form.activity_explain"  placeholder="活动说明"></el-input>
      </el-form-item>
      <el-form-item label="线上优惠券">
        <el-form-item
                v-for="(item, index) in form.rule"
                :label="'线上优惠券.' + (index+1) "
                :key="index"
                :prop="'rule.' + index + '.value'"
                :rules="rules">
          <el-select v-model="item.card_id" @change="changeCard(index)" placeholder="请选择优惠券" filterable >
            <el-option :label="v.title" :value="v.card_id" v-for="(v,i) in cardList" :key="v.card_id" ></el-option>
          </el-select>

          <div @click="handleImgPicker('card',index)" class="upload-box">
            <img v-if="item.img" :src="item.img" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
          </div>
          <el-input type="text" v-model="item.info" style="display: none" ></el-input>
          <el-button @click.prevent="removeRule(item)">删除</el-button>
        </el-form-item>
        <el-button type="text" @click="addRule"  >+线上优惠券</el-button>
      </el-form-item>
      <el-form-item label="线下优惠券">
        <el-form-item
                v-for="(item, index) in form.rule2"
                :label="'线下优惠券.' + (index+1) "
                :key="index"
                :prop="'rule2.' + index + '.value'"
                :rules="rules2">
          <el-select v-model="item.id" @change="changeCard2(index)" placeholder="请选择优惠券" filterable >
            <el-option :label="v.apprange_name" :value="v.id" v-for="(v,i) in cardList2" :key="v.id" ></el-option>
          </el-select>
          <div @click="handleImgPicker('xxcard',index)" class="upload-box">
            <img v-if="item.img" :src="item.img" class="avatar"/>
            <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
          </div>
          <el-input type="text" v-model="item.info" style="display: none" ></el-input>
          <el-button @click.prevent="removeRule2(item)">删除</el-button>
        </el-form-item>
        <el-button type="text" @click="addRule2"  >+线下优惠券</el-button>
      </el-form-item>
      <!--
      <el-card header="图文详情" shadow="never" v-loading="">
        <template v-if="mode === 'richText'">
          <vue-html5-editor :content="form.contents" ref="editor" @change="updateContent" :height="360"></vue-html5-editor>
          <span class="tpl_item img" @click="addImgPreview" style="">
            <i class="iconfont icon-image"></i>图片
          </span>
        </template>
        <imgPicker :dialog-visible="thumbDialog" :sc-status="isGetThumb" :isMost="true" @chooseImg="pickThumb" @closeImgDialog="closeThumbDialog"></imgPicker>
      </el-card>
      -->

      <imgPicker
              :dialog-visible="imgDialog"
              :sc-status="isGetImage"
              @chooseImg="pickImg"
              @closeImgDialog="closeImgDialog"
      ></imgPicker>
    </el-form>
    <div slot="footer" class="dialog-footer content-center">

      <el-button type="primary" @click="handleSave" v-if="this.copy_flag" :loading="submitLoading"> 复制活动 </el-button>
      <el-button type="primary" @click="handleSave" v-else :loading="submitLoading"> 确定 </el-button>
    </div>
  </div>

</template>
<script>
    import { mapGetters } from 'vuex'
    import {getDistributorselfActivityDetail,getCardList,getOfflineList,saveCouponActivity,getCouponActivityDetail} from '../../../api/cardticket'

    import richTextEditor from '@/components/function/richTextEditor'
    import imgPicker from '@/components/imageselect'
    export default {
        components: {
            imgPicker,
            richTextEditor,
        },
        data () {
            return {
                pickerImgType: "",
                pickerImgType_index:"",
                copy_flag:false,
                clickable:false,
                dialog: false,
                distributor_dialog:false,
                relDistributors:[],
                DistributorVisible: false,
                DistributorStatus: false,
                isValid: true,
                activeName: 'admin',
                list: [],
                total_count: 0,
                loading: false,
                DistributorName:'',
                form: {
                    id:'',
                    name:'',
                    banner:'',
                    activity_time:'',
                    activity_explain:'',
                    card_color:'',
                    key_words:'',
                    cards_img:'',
                    show_type:'',
                    rule: [{
                        card_id:'',
                        card_name:'',
                        card_yh_price:'',
                    }],
                    rule2: [{
                        card_id:'',
                        card_name:'',
                        card_yh_price:'',
                    }]
                },
                active_time_f : '',
                deadline_time : '',
                date_time : '',
                mode: 'richText',
                thumbDialog:false,
                picsDialog: false,
                imgDialog: false,
                isGetImage: false,
                isGetThumb: false,
                imgIndex: 0,
                submitLoading:false,
                cardList: [],
                cardList2:[],
                rules:{ required: true,  trigger: 'blur'},
                rules2:{ required: true,  trigger: 'blur'},
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            getCard(){
                getCardList({card_type:'cash',page:1,page_size:10000}).then(res=>{
                    if(res.data){
                        this.cardList = res.data.data.list
                    }
                })
            },
            getCard2(){
              //线下优惠券
                getOfflineList({page:1,pageSize:10000}).then(res=>{
                    if(res.data){
                        this.cardList2 = res.data.data.list
                    }
                })
            },
            addRule(){
                this.form.rule.push({
                    card_id:'',
                    card_name:'',
                    card_yh_price:'',
                });

            },
            removeRule(item){
                var index = this.form.rule.indexOf(item)
                if (index !== -1) {
                    this.form.rule.splice(index, 1)
                }
            },
            changeCard(index){
                var card = this.form.rule[index].card_id
                var i=this.cardList.map((item) => item.card_id).indexOf(card);
                // this.form.rule[index].info=JSON.stringify(this.cardList[i]);
                this.form.rule[index].card_id = this.cardList[i].card_id;
                this.form.rule[index].card_name = this.cardList[i].title;
                this.form.rule[index].card_yh_price = this.cardList[i].reduce_cost / 100 ;
            },
            addRule2(){
                console.log(this.form.rule2.length)
                this.form.rule2.push({
                    card_id:'',
                    card_name:'',
                    card_yh_price:'',
                });

            },
            removeRule2(item){
                var index = this.form.rule2.indexOf(item)
                if (index !== -1) {
                    this.form.rule2.splice(index, 1)
                }
            },
            changeCard2(index){
                var card = this.form.rule2[index].id
                var i=this.cardList2.map((item) => item.id).indexOf(card);
                // this.form.rule2[index].info=JSON.stringify(this.cardList2[i]);
                this.form.rule2[index].card_id = this.cardList2[i].id;
                this.form.rule2[index].card_name = this.cardList2[i].apprange_name;
                this.form.rule2[index].card_yh_price = this.cardList2[i].perputoutvalue;
            },
            updateContent: function (data) {
                this.form.contents = data
            },

            handleCurrentChange (val) {
                this.currentPage = val
                this.loading = false
            },
            // 详情中的上传图片
            addImgPreview: function () {
                this.thumbDialog = true
                this.isGetThumb = true
            },
            closeThumbDialog: function () {
                this.thumbDialog = false
                this.isGetThumb = false
            },
            pickThumb: function (arr) {
                if (arr.length != 0) {
                    arr.forEach(data => {
                        if (data && data.url !== '') {
                            this.thumbDialog = false
                            var index = this.$refs.editor.$el.id
                            var loc = this.$refs.editor
                            var img = new Image()
                            img.src = this.wximageurl + data.url
                            if (loc.range) {
                                loc.range.insertNode(img)
                                var referenceNode = loc.range.endContainer
                                if (referenceNode.className !== 'content') {
                                    loc.range.setStartAfter(referenceNode)
                                } else {
                                    loc.range.setStart(loc.range.endContainer, loc.range.endOffset)
                                }
                            } else {
                                loc.$refs.content.appendChild(img)
                                loc.focus()
                                loc.restoreSelection()
                            }
                            this.form.contents = loc.$refs.content.innerHTML
                        }
                    })
                }
            },

            // 保存
            handleSave(){

                const that = this
                console.log(this.form)
                saveCouponActivity(this.form).then(res => {
                    this.$message({
                        message: '添加成功',
                        type: 'success',
                        duration: 2 * 1000,
                        onClose () {
                            that.$router.go(-1)
                        }
                    })
                }).catch( error  => {
                    this.$message.error('添加失败!')
                    this.submitLoading = false
                })
            },
            handleImgPicker (pickerImgType, index = 0) {
                this.pickerImgType = pickerImgType
                this.pickerImgType_index = index;
                this.imgDialog = true
                this.isGetImage = true
            },

            closeImgDialog () {
                this.imgDialog = false
                this.isGetImage = false
            },
            pickImg (data) {
                if(this.pickerImgType == "card"){
                    this.form.rule[this.pickerImgType_index].img = data.url;
                }else if(this.pickerImgType == "xxcard"){
                    this.form.rule2[this.pickerImgType_index].img = data.url;
                }else if (this.pickerImgType == "b"){
                    this.form.cards_img = data.url
                }else{
                    this.form.banner = data.url
                }
                this.imgDialog = false
            },
            getDetail(id){
                getCouponActivityDetail(id).then(res=>{
                    let data = {
                        // 复制活动提交去掉秒杀id
                        id: this.copy_flag ? '' : res.data.data.id,
                        name:res.data.data.name,
                        banner:res.data.data.banner,
                        activity_time:res.data.data.activity_time,
                        activity_explain:res.data.data.activity_explain,
                        rule:res.data.data.card_msg,
                        rule2:res.data.data.xxcard_msg,
                        key_words:res.data.data.key_words,
                        show_type:res.data.data.show_type,
                        cards_img:res.data.data.cards_img
                    }
                    Object.assign(this.form, data)

                })
            }
        },
        mounted () {
            this.getCard();
            this.getCard2();
            if (this.$route.params.id) {
                this.getDetail(this.$route.params.id);
            }
            // 复制活动
            if (this.$route.query.copyid){
                this.copy_flag = true
                this.getDetail(this.$route.query.copyid);
            }
        }

    }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vue-html5-editor {
    vertical-align: top;
    display: inline-block;
  }
  .vue-html5-editor {
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// couponActivityedit.vue?f349c7c2